import { Accordion, AccordionDetails, Divider, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ResidencePermitVM } from 'shell/view-models/search-anpr';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersPersonSearch } from 'shell/constants/filters-person-search';

interface FiltersResidencePermitProps {
  open?: boolean;
  onOpenAccordion: (value: FiltersPersonSearch) => void;
  values?: ResidencePermitVM;
  onChange: (
    key: keyof ResidencePermitVM,
    value: ResidencePermitVM[keyof ResidencePermitVM]
  ) => void;
  errors?: FormikErrors<ResidencePermitVM>;
  touched?: FormikTouched<ResidencePermitVM>;
}

const FiltersResidencePermit = ({
  values,
  onChange,
  open,
  onOpenAccordion,
  errors,
  touched,
}: FiltersResidencePermitProps): React.ReactElement => {
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        onOpenAccordion(FiltersPersonSearch.ResidencePermit);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-filters-residence-permit-content"
        id="panel-person-filters-residence-permit-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Ricerca per Permesso di soggiorno</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <PmiTextField
              aria-label="Numero Permesso"
              label="Numero Permesso *"
              id="permitNumber"
              name="permitNumber"
              fullWidth
              type="text"
              inputProps={{
                maxLength: '20',
              }}
              variant="outlined"
              value={values?.permitNumber}
              onChange={(event) => onChange('permitNumber', event.target.value)}
              error={touched?.permitNumber && Boolean(errors?.permitNumber)}
              helperText={errors?.permitNumber}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              aria-label="Questura"
              label="Questura"
              id="preccint"
              name="preccint"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.preccint}
              inputProps={{
                maxLength: '20',
              }}
              onChange={(event) => onChange('preccint', event.target.value)}
              error={touched?.preccint && Boolean(errors?.preccint)}
              helperText={errors?.preccint}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <PmiTextField
              aria-label="Numero Passaporto"
              label="Numero Passaporto"
              id="passportNumber"
              name="passportNumber"
              fullWidth
              type="text"
              variant="outlined"
              inputProps={{
                maxLength: '30',
              }}
              value={values?.passportNumber}
              onChange={(event) => onChange('passportNumber', event.target.value)}
              error={touched?.passportNumber && Boolean(errors?.passportNumber)}
              helperText={errors?.passportNumber}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersResidencePermit.displayName = 'Filters Person Residence Permit component';

export default FiltersResidencePermit;
